import { StringField } from "../../../types/types";
import {
  LanguageDropdownFields,
  LanguageDropdownProps,
  LanguageDropdown,
} from "../types/LanguageDropdown.types";

export class LanguageDropdownModel {
  private readonly fields?: LanguageDropdownFields;

  constructor(props: LanguageDropdownProps) {
    this.fields = props.fields;
  }

  get title(): StringField | undefined {
    return this.fields?.Title
  }
}
